// src/components/Header.jsx
import { Link } from 'react-router-dom';

export default function Header() {
  return (
    <header className="relative">
      <div className="max-w-6xl mx-auto">
        <div
          className="relative flex min-h-[420px] md:min-h-[550px] flex-col gap-6 bg-cover bg-center bg-no-repeat items-start justify-end px-6 pb-12 md:pb-20 overflow-hidden"
          style={{
            backgroundImage: `linear-gradient(to top, #05080f 0%, rgba(5,8,15,0.6) 40%, rgba(5,8,15,0.3) 100%), 
                             url('https://www.thecodefitness.com/wp-content/uploads/2021/01/IMG_4213-1024x636.jpg')`
            // ↑ Yeh ek high-quality Ludhiana gym image hai (pink neon lighting wala modern look)
            // Agar apni real photo upload karoge to uska direct URL yahan daal dena
          }}
        >
          {/* Strong dark overlay for text visibility */}
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/50 to-black/80" />

          <div className="relative z-10 w-full max-w-4xl">
            {/* Open Now Badge */}
            <div className="inline-flex items-center gap-3 mb-5">
              <span className="flex h-3 w-3 relative">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
                <span className="relative inline-flex rounded-full h-3 w-3 bg-primary"></span>
              </span>
              <span className="text-primary text-sm md:text-base font-bold uppercase tracking-widest">
                Open Now
              </span>
            </div>

            {/* Powerful Headline */}
            <h1 className="text-white text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black leading-tight tracking-tight mb-5 md:mb-8">
              Train Hard.<br />
              Become Unstoppable.
            </h1>

            {/* Motivational Tagline */}
            <p className="text-slate-200 text-base sm:text-lg md:text-xl font-light leading-relaxed max-w-2xl mb-8 md:mb-10">
              Premium equipment, expert guidance, and a community that pushes you to your limits. Welcome to KrioGym Ludhiana – where real transformations happen.
            </p>

            {/* Call-to-Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/exercises"
                className="group bg-primary text-black px-8 py-4 rounded-full text-lg md:text-xl font-bold shadow-[0_0_30px_rgba(204,255,0,0.5)] hover:shadow-[0_0_40px_rgba(204,255,0,0.7)] transition-all duration-300 active:scale-95 flex items-center justify-center gap-3"
              >
                Explore Workouts
                <span className="material-symbols-outlined text-2xl transition-transform duration-300 group-hover:translate-x-2">
                </span>
              </Link>

              <Link
                to="/contact"
                className="border-2 border-primary/70 text-primary px-8 py-4 rounded-full text-lg md:text-xl font-bold hover:bg-primary/10 transition-all duration-300"
              >
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

// import { Link } from 'react-router-dom';

// export default function Header() {
//   return (
//     <header className="relative">
//       <div className="max-w-xl mx-auto">
//         <div 
//           className="relative flex min-h-[380px] flex-col gap-4 bg-cover bg-center bg-no-repeat items-start justify-end px-5 pb-8 overflow-hidden"
//           style={{
//             backgroundImage: `linear-gradient(to top, #05080f 0%, rgba(5,8,15,0.4) 50%, rgba(5,8,15,0.4) 100%), url('https://lh3.googleusercontent.com/...your-image-url...')`
//           }}
//         >
//           <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-background-dark"></div>
//           <div className="relative z-10 w-full">
//             <div className="inline-flex items-center gap-2 mb-3">
//               <span className="flex h-2 w-2 relative">
//                 <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
//                 <span className="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
//               </span>
//               <span className="text-primary text-[10px] font-bold uppercase tracking-widest">Open Now</span>
//             </div>
//             <h1 className="text-white text-4xl font-black leading-none tracking-tight mb-2">
//               Train <span className="text-primary text-glow">Free</span>.<br/>
//               Train Hard.
//             </h1>
//             <p className="text-slate-300 text-sm font-light leading-relaxed max-w-[90%] mb-4">
//               Ludhiana's first open-access gym. No memberships, just pure fitness powered by community.
//             </p>
//             <div className="flex gap-3">
//               <Link 
//                 to="/exercises"
//                 className="bg-primary text-black px-6 py-2.5 rounded-full text-sm font-bold shadow-[0_0_15px_rgba(204,255,0,0.4)] transition-transform active:scale-95"
//               >
//                 Start Moving
//               </Link>
//             </div>
//           </div>
//         </div>
//       </div>
//     </header>
//   );
// }